import { Button, BUTTON_TYPES } from 'components/Button'
import { ReactComponent as Plus16 } from 'assets/svg/Plus16.svg'
import { ACTIONS, Can, SUBJECTS } from '../Permission'
import useRouter from '../../hooks/useRouter'
import { routes } from '../../router'
import { BTN_TXT } from 'constants/txt'

export const CreateContractType = () => {
  const { push, query } = useRouter()

  return (
    <Can I={ACTIONS.CREATE} a={SUBJECTS.CONTRACTS}>
      <Button
        type={BUTTON_TYPES.PRIMARY}
        icon={<Plus16 />}
        onClick={() =>
          push(`${routes.contracts}/${query?.type ? query.type : ''}/create`)
        }
        upperCase
      >
        {BTN_TXT.CREATE_CONTACT}
      </Button>
    </Can>
  )
}
